import { createContext, useContext, type ReactNode } from 'react';

import { useAccountPoll, type UseAccountPollResult } from './useAccountPoll';
import { useSelection } from '../selection/SelectionContext';
import { useSession } from '../session/SessionContext';

const AccountContext = createContext<UseAccountPollResult | null>(null);

/**
 * Runs the GET /account poll once for the whole signed-in view. The header
 * wallet popover, withdraw form and activity list all read from here so they
 * cannot drift apart — and so switching mints does not multiply the poll rate.
 */
export function AccountProvider({ children }: { children: ReactNode }) {
  const { session, api } = useSession();
  const { selection } = useSelection();
  const value = useAccountPoll(api, session?.customerId, {
    selectedMintId: selection?.mintId,
  });

  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>;
}

export function useAccount(): UseAccountPollResult {
  const ctx = useContext(AccountContext);
  if (!ctx) {
    throw new Error('useAccount must be used inside <AccountProvider>');
  }
  return ctx;
}
